import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 20223-09-11
 * @brief SEI 사업장 관리 개발
 *
 ********************************************************************/
// utils
import { useRecoilValue } from "recoil";
import { siteState } from "../../../recoil/menuState";
import CompanyInsert from "./company/CompanyInsert";
import CompanyUpdate from "./company/CompanyUpdate";
import CompanyView from "./company/CompanyView";
import ZoneInsert from "./zone/ZoneInsert";
//component
function SiteCRUD(props) {
    //recoil
    const siteStates = useRecoilValue(siteState);
    //props
    const { handleOpenPop, workMode, setWorkMode } = props;
    return (_jsxs(_Fragment, { children: [siteStates.siteType == "company" && siteStates.companyId.length > 0 && workMode === "READ" && (_jsx(CompanyView, { setWorkMode: setWorkMode, handleOpenPop: handleOpenPop })), siteStates.siteType == "company" && workMode === "CREATE" && _jsx(CompanyInsert, { setWorkMode: setWorkMode }), siteStates.siteType == "company" && workMode === "UPDATE" && _jsx(CompanyUpdate, { setWorkMode: setWorkMode }), siteStates.siteType !== "company" && workMode === "CREATE" && (_jsx(ZoneInsert, { setWorkMode: setWorkMode, handleOpenPop: handleOpenPop }))] }));
}
export default SiteCRUD;
